import PropTypes from 'prop-types'
import React from 'react'
import { compose, withProps } from 'recompose'

import { record as ChannelRecord } from 'data/channels'
import { providesChannelMutations } from 'components/Channels/dataSync'
import { makeToggleable } from 'components/Utils/toggleable'
import Confirm from 'components/Utils/Modal/Confirm'
import { Text } from 'components/base'

export function Leave({
  channel,
  leaveChannel,
  children,
  className,
  isModalOpen,
  openModal,
  closeModal,
}) {
  return (
    <div className={className}>
      <Confirm
        show={isModalOpen}
        onConfirm={leaveChannel}
        onCancel={closeModal}
        confirmLabel="Leave channel"
      >
        <div>
          <Text.Subtitle>
            You will not be able to join it again without being invited.
          </Text.Subtitle>

          <Text.Corpus className="margin-vertical-large">
            Are you sure you want to leave the{' '}
            <span className="bold">{channel.name}</span> channel?
          </Text.Corpus>
        </div>
      </Confirm>
      <div onClick={openModal}>{children}</div>
    </div>
  )
}

const ConnectedLeave = compose(
  providesChannelMutations,
  makeToggleable({
    attrName: 'isModalOpen',
    toggleOnName: 'openModal',
    toggleOffName: 'closeModal',
    toggleName: 'toggleModal',
    defaultValue: false,
  }),
  withProps(({ leaveChannel, closeModal, onLeave, channel }) => ({
    leaveChannel: event => {
      closeModal(event)
      onLeave()
      leaveChannel({ id: channel.id })
    },
  }))
)(Leave)

ConnectedLeave.propTypes = {
  channel: PropTypes.instanceOf(ChannelRecord).isRequired,
  onLeave: PropTypes.func.isRequired, // kind of callback
}

ConnectedLeave.defaultProps = {
  onLeave: () => {},
}

export default ConnectedLeave
